<template>
    <div>
        <GoogleMap ref="mapRef" api-key="AIzaSyDpKhw-3bVMsx_pSXMVcregBPBWZqBjDxs" :libraries="['visualization']" style="width: 100%; height: 100vh" mapTypeId="terrain" :center="center" :zoom="15">
            <CustomMarker v-for="(location, i) in locations" :options="{ position: location }" :key="i">
                <div style="text-align: center">
                    <img src="/static/assets/src/img/icons/radial_custom_heatmap_marker_sm.png" alt="test one" width="50" height="50" />
                </div>
            </CustomMarker>
        </GoogleMap>
    </div>
</template>
<script>
import { GoogleMap, CustomMarker } from "vue3-google-map";
import {  defineComponent, ref, watch } from "vue";
export default defineComponent({
  name: "Market Research Map",
  components: { GoogleMap, CustomMarker  },
  props: {
    locations: [],
    locationselect: '',
    maptype: 'markers',
    // heatmaplocations: []
  },
  setup(props) {
    const mapRef = ref(null);
    const markersArray = props.locations;
    watch(
        () => mapRef.value?.ready,
        (ready) => {
        if (!ready) return;
            mapFitBounds(mapRef, markersArray);
        }
    );
    function mapFitBounds(mapRef, markers) {
        let bounds;
        const api = mapRef.value.api;
        const map = mapRef.value.map;
        bounds = new api.LatLngBounds();
        for (let i = 0; i < markers.length; i++) {
            bounds.extend(markers[i]);
        }
        map.fitBounds(bounds);
    }
    return { mapRef }
  }
});
</script>